import { mixpanelProjectKeys, mixpanelProjectProxy } from "@/config/constants"
import type { CustomMixpanel } from "@/plugins/mixpanel/types"
import { useConfigStore } from "@/stores/config"
import mixpanel, { type OverridedMixpanel } from "mixpanel-browser"
import type { App } from "vue"

export const MixpanelInstance: CustomMixpanel | OverridedMixpanel = mixpanel

let isInitialized = false
export function isMixpanelInitialized() {
  return isInitialized
}

export async function initMixpanel(uuid: string, email: string, lang: string) {
  // set project key to use, depends of execution environment
  const env = useConfigStore().mixpanel

  if (env === "test" || env === "production") {
    MixpanelInstance.init(mixpanelProjectKeys[env], {
      // 'debug' param can add some logs in console to know what is sent
      api_host: mixpanelProjectProxy[env],
      record_mask_text_selector: "",
      record_idle_timeout_ms: 1200000, //20min
      record_max_ms: 2700000, //45min
      loaded: function () {
        MixpanelInstance.register({
          email: email,
          user_uuid: uuid,
          language: lang,
        })

        MixpanelInstance.identify(uuid)

        MixpanelInstance.set_config({
          batch_flush_interval_ms: 1000,
        })

        isInitialized = true
      },
    })
  }
}

export default {
  install: (app: App) => {
    app.config.globalProperties.$mixpanel = MixpanelInstance
    app.provide("mixpanel", MixpanelInstance)
  },
}
